<template>
  <v-app
    style="width: 100%"
    class="pa-3 pt-0"
  >
    <div style="position: fixed;background-color: #fff;border-radius: 10px;padding: 10px;z-index: 10">
      <div class="d-flex">
        <v-btn
          v-shortkey="['f8']"
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 10px"
          @shortkey="print"
          @click="print"
        >
          <v-icon
            color="pOrrange"
            style="font-size: 18px"
            class="me-2"
          >
            mdi-printer-outline
          </v-icon>
          {{ $t('print') }} (f8)
        </v-btn>
        <v-btn
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 10px"
          :loading="loading"
          @click="captureAndSharePDF('pdf')"
        >
          <v-icon
            color="pOrrange"
            style="font-size: 18px"
            class="me-2"
          >
            mdi-file-pdf-box
          </v-icon>
          {{ $t('getFilepdf') }}
        </v-btn>
        <v-btn
          color="primary"
          small
          class="me-2 mt-1 mb-1"
          outlined
          style="font-size: 10px"
          :loading="loading"
          @click="captureAndSharePDF('share')"
        >
          <v-icon
            color="pOrrange"
            style="font-size: 18px"
            class="me-2"
          >
            mdi-share-variant-outline
          </v-icon>
          {{ $t('share') }}
        </v-btn>
      </div>
    </div>
    <v-row class="mx-3 mb-4 mt-14">
      <v-expansion-panels
        v-model="panel"
        class="mt-2 px-0"
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $t('printAndPageSetting') }}
            ✏️
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col md="3">
                <p class="mb-0 mt-1">
                  {{ $t('orientationPage&size') }} :
                </p>
              </v-col>
              <v-col md="3">
                <v-radio-group
                  v-model="size"
                  row
                  hide-details
                  class="me-9 mt-0"
                >
                  <v-radio
                    :label="$t('A5')"
                    value="a5"
                  />
                  <v-radio
                    :label="$t('A4')"
                    value="a4"
                  />
                </v-radio-group>
              </v-col>
              <v-col md="3">
                <v-radio-group
                  v-model="layout"
                  row
                  hide-details
                  class="mt-0"
                >
                  <v-radio
                    :label="$t('portrait')"
                    value="portrait"
                  />
                  <v-radio
                    :label="$t('landscape')"
                    value="landscape"
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row
              v-if="layout === 'portrait'"
              class="setting-layout"
            >
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('designing') }} : <templateSelector v-model="template" />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                {{ $t('coloring') }} : <colorSelector v-model="color" />
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <div
      id="print"
      style="direction: rtl;background-color: white;color: #000000"
      class="px-3 mx-auto main-layout"
      :style="{'zoom' : (isMobile && !pdfGenerate ? (layout === 'portrait' ? '0.45' : '0.33'): null), 'main-layout': (isMobile && !pdfGenerate ? '0.45' : '1')}"
    >
      <div
        v-for="(page, i) in printPage"
        :key="i"
        :class="[layoutClass]"
        class=" pagemargins"
        :style="{'page-break-before':(i>0 ? 'always' : null)}"
      >
        <!--        header-->
        <div
          class="header-print"
          style="border: 0px !important;"
        >
          <div
            v-if="template && color"
            class="page-background-print"
          >
            <printBackground
              :template="template + (layout === 'landscape' ? '-land' : '')"
              :color="color"
            />
          </div>
        </div>
        <!--        body-->
        <div
          class="body-print"
          style="z-index: 2;position: absolute;padding: 0cm 0.4cm"
          :style="{'top':(template && template !== 'undefined' && color ? '2.1cm' : '0.5cm')}"
        >
          <div
            style="width: 100%;right: 0;margin-bottom: 0.4cm"
          >
            <div
              class="top-header-print"
              style="display: flex;width: 100%;padding: 5px"
            >
              <div style="width: 25%;padding-right: 0.5cm">
                <img
                  class="ms-2"
                  :src="(base64Logo ? 'data:image/png;base64,' + base64Logo : '')"
                  width="65"
                  style="max-height: 65px"
                >
              </div>
              <div style="width: 50%;text-align: center">
                <h3>{{ $store.state.abrName }}</h3>
                <h4>{{ title }}</h4>
                <h5>{{ (fromDate ? $t('fromDate') + ' : ' + fromDate : '') }} {{ (fromDate && toDate ? ' - ' : '') }} {{ (toDate ? $t('toDate') + ' : ' + toDate : '') }}</h5>
              </div>
              <div
                class="float-end"
                style="width: 25%;padding-right: 1cm;padding-top: 8px;font-size:10px"
              >
                <div>{{ $t('reportDate') }} : {{ getToday() }}</div>
                <div>{{ $t('currency') }} : {{ (currencyProp ? currencyProp.name : $store.state.currency.name) }}</div>
              </div>
            </div>
          </div>
          <!--          table header-->
          <div
            v-show="!page.hideHeader"
            class="table-header-print"
          >
            <div
              class="table-header-td-print"
              style="width: 5%"
            >
              #
            </div>
            <div
              v-for="(head, h) in headerProp"
              :key="h"
              class="table-header-td-print"
              :style="{width: head.width ? head.width + '%' : autoWidth + '%'}"
            >
              {{ head.text }}
            </div>
          </div>
          <!--          table body-->
          <div
            v-for="(item, m) in page.items"
            :key="m"
            style="display: flex"
            class="print-article show-header"
            v-html="item"
          />
        </div>
        <div
          class="footer-page-print"
          :style="{'bottom' : (template && color ? '25px' : '13px')}"
        >
          {{ $t('page') }} {{ page.page }} {{ $t('from') }} {{ printPage.length }}
        </div>
        <div
          class="footer-abriron-print"
          :style="{'bottom' : (template && color ? '25px' : '13px')}"
        >
          {{ $t('FinancialSolutionsAbriron') }}
        </div>
      </div>
    </div>
    <div
      ref="refItems"
      style="display:none;width: 21cm;"
    >
      <div
        v-for="(item, j) in items"
        :key="j"
        style="display: flex;"
        class="print-row"
      >
        <div
          class="table-body-td-print"
          style="width: 5%"
        >
          {{ j+1 }}
        </div>
        <div
          v-for="(head, b) in headerProp"
          :key="b"
          class="table-body-td-print"
          :style="{ width: head.width ? head.width + '%' : autoWidth + '%' }"
          :class="{ 'sum-type': head.sum }"
        >
          <div v-if="head.value === 'contentTurnover'">
            <div v-if="item.head.ref_type !== 'transfer'">
              {{ item.content }}
            </div>
            <div v-if="item.head.ref_type === 'transfer'">
              {{ (!showSummaryTransferContentProp ? item.content : $t('transferDocumentFrom') + ' ' + (item.fin4 ? item.fin4.name : '')) }}
            </div>
            <div
              v-if="item.reference && item.reference.article && dataProp && dataProp.showInvoiceDetail"
              style="margin-bottom: 6px"
            >
              <v-simple-table
                dense
                class="v-data-table__wrapper__height_off"
                style="background-color: #e3e3e3;"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th
                        style="width: 50%;font-size: 9px !important;white-space:inherit !important;"
                        class="text-center"
                      >
                        {{ $t('product-name') }}
                      </th>
                      <th
                        style="width: 50%;font-size: 9px !important;"
                        class="text-center"
                      >
                        {{ $t('count') }} / {{ $t('fee') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(article, i) in item.reference.article"
                      :key="i"
                    >
                      <td
                        style="width: 50%;font-size: 9px !important;white-space:inherit !important;"
                        class="text-center"
                      >
                        {{ article.product.name }}
                      </td>
                      <td
                        style="width: 50%;font-size: 9px !important;"
                        class="text-center"
                      >
                        <div>
                          {{ article.count }} ×
                        </div>
                        <div>
                          {{ $numberFormat(article.fee) }}
                        </div>
                        <div>
                          {{ $numberFormat((+(article.count * article.fee) - + article.discount + +article.tax).toFixed($store.state.currency.decimal)) }} =
                        </div>
                      </td>
                    </tr>
                    <tr v-if="item.reference.discount && item.reference.discount > 0">
                      <td
                        style="width:50%;font-size: 9px !important;"
                        class="text-center"
                      >
                        {{ $t('discount') }}
                      </td>
                      <td
                        style="font-size: 9px !important;"
                        class="text-center"
                      >
                        <div>
                          {{ $numberFormat(item.reference.discount) }}
                        </div>
                      </td>
                    </tr>
                    <tr v-if="item.reference.tax && item.reference.tax > 0">
                      <td
                        style="width:50%;font-size: 9px !important;"
                        class="text-center"
                      >
                        {{ $t('tax') }}
                      </td>
                      <td
                        style="font-size: 9px !important;"
                        class="text-center"
                      >
                        <div>
                          {{ $numberFormat(item.reference.tax) }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
            <div
              v-if="item.reference && item.reference.content"
              class="mb-1"
            >
              -  {{ item.reference.content }}
            </div>
          </div>
          <div v-else>
            <div v-if="head.type === 'number'">
              <div v-if="typeof item[head.value.split('.')[0]] === 'object' && item[head.value.split('.')[0]] !== null">
                <div v-if="head.value.includes('.')">
                  {{ $numberFormat(item[head.value.split('.')[0]][head.value.split('.')[1]]) }}
                </div>
              </div>
              <div v-else>
                {{ $numberFormat(item[head.value]) }}
              </div>
            </div>
            <div v-else-if="head.type === 'translate'">
              {{ $t(item[head.value]) }}
            </div>
            <div v-else-if="typeof item[head.value.split('.')[0]] === 'object' && item[head.value.split('.')[0]] !== null">
              <div v-if="head.value.includes('.')">
                {{ item[head.value.split('.')[0]][head.value.split('.')[1]] }}
              </div>
              <div v-else>
                {{ item[head.value].number || item[head.value].name || item[head.value].title || item[head.value].text || item[head.value].remain }}
              </div>
            </div>
            <div v-else-if="Array.isArray(item[head.value]) && item[head.value].length > 0">
              {{ item[head.value][0].name || item[head.value][0].title || item[head.value][0].text || item[head.value][0].number || item[head.value].date || item[head.value].remain }}
            </div>
            <div v-else>
              {{ item[head.value] }}
            </div>
          </div>
        </div>
      </div>
      <!--  sum row-->
    </div>
    <v-dialog
      v-model="customSizeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="60%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="customSizeDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print-size') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
            <v-text-field
              v-model="width"
              outlined
              dense
              type="number"
              :label="$t('width') + '(cm)'"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
            <v-text-field
              v-model="height"
              outlined
              dense
              type="number"
              :label="$t('height') + '(cm)'"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                color="primary"
                @click="setCustomeSize"
              >
                {{ $t('submit') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="customSizeDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : '')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import store from '../../../../../store'
import General from '../../../../../Mixins/general'
import templateSelector from './partial/printTemplateSelector.vue'
import colorSelector from './partial/printColorSelector.vue'
import printBackground from './partial/printBackground.vue'
export default {
  components: {
    templateSelector,
    colorSelector,
    printBackground
  },
  mixins: [General],
  props: ['headerProp', 'itemsProp', 'title', 'idProp', 'dialog', 'fromDate',
    'toDate',
    'productItemsInvoice',
    'dataProp',
    'reviewTotalsProp',
    'showSummaryTransferContentProp',
    'invoiceTotalsProp',
    'reviewLevelProp',
    'typeProp',
    'currencyProp',
    'turnoverProp'],
  data () {
    return {
      printPage: [],
      headerPrint: [],
      items: [],
      printType: 'unofficial',
      timer: 0,
      loading: false,
      showRemain: false,
      size: 'a4',
      layout: 'portrait',
      base64Logo: null,
      showArticleContent: null,
      template: null,
      showEntrepotArticle: null,
      color: null,
      type: null,
      snakbarColor: null,
      officialNumber: null,
      snakbarText: null,
      snakbar: null,
      content: null,
      id: null,
      date: null,
      account: null,
      number: null,
      currency_amount: null,
      dueDate: null,
      currency: null,
      tax: null,
      discount: null,
      entrepot: null,
      totalTax: null,
      totalDiscount: null,
      totalCount: null,
      totalFee: null,
      sum: null,
      uid: null,
      width: null,
      height: null,
      user: null,
      customer: null,
      currencyName: '',
      self: null,
      headers: null,
      pdfGenerate: false,
      decimal: 0,
      customSizeDialog: null,
      printSize: '29.7cm 21cm'
    }
  },
  computed: {
    autoWidth () {
      const totalWidth = this.headerProp.reduce((sum, head) => sum + (head.width ? parseFloat(head.width) : 0), 0)
      const remainingWidth = 100 - totalWidth
      const emptyColumns = this.headerProp.filter(head => !head.width).length
      return emptyColumns > 0 ? remainingWidth / emptyColumns : 0
    },
    layoutClass () {
      var classObject = ''
      if (this.layout === 'portrait') {
        classObject = {
          'main-page-print': true,
          'border-off': this.pdfGenerate
        }
      } else {
        classObject = {
          'main-page-landscape-print': true,
          'border-off': this.pdfGenerate
        }
      }
      return classObject
    },
    isMobile () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    totals: function () {
      return 1
    }
  },
  watch: {
    dialog (val) {
      if (val) {
        this.renderPrinter()
      }
    },
    showRemain () {
      this.renderPrinter()
      this.setCookie('showRemain', this.showRemain)
    },
    showArticleContent () {
      this.renderPrinter()
    },
    template () {
      this.renderPrinter()
    },
    layout (val) {
      if (val === 'landscape') {
        this.template = null
      }
      this.renderPrinter()
      if (val) {
        localStorage.setItem('invoicePrintLayout', val)
      } else {
        localStorage.removeItem('invoicePrintLayout')
      }
    },
    size (val) {
      this.renderPrinter()
      if (val) {
        localStorage.setItem('invoicePrintSize', val)
      } else {
        localStorage.removeItem('invoicePrintSize')
      }
    },
    color (val) {
      // this.renderPrinter()
    },
    showEntrepotArticle () {
      this.renderPrinter()
    },
    printType () {
    },
    headerProp () {
      // this.head = this.itemsProp
    },
    itemsProp () {
      this.items = this.itemsProp
      this.renderPrinter()
    },
    items (val) {
      this.renderPrinter()
    }
  },
  beforeMount () {
    var storage = JSON.parse(localStorage.getItem('token'))
    if (storage != null) {
      store.commit('SET_START_DATE', storage.init.startDate)
      store.commit('SET_END_DATE', storage.init.endDate)
      store.commit('SET_DATE_LOCALE', storage.init.date_locale.value)
      if (storage.init.date_locale.value === 'fa,en') {
        store.commit('SET_DATE_FORMAT', 'jYYYY/jMM/jDD')
      } else {
        store.commit('SET_DATE_FORMAT', 'YYYY/MM/DD')
        store.commit('SET_START_DATE', null)
        store.commit('SET_END_DATE', null)
      }
      store.commit('SET_RTL', storage.init.rtl.value)
      store.commit('SET_DARK', storage.init.dark.value)
      store.commit('SET_LANG', storage.init.lang.value)
      store.commit('SET_THEME_COLOR', storage.init.theme_color.value)
    }
    this.$vuetify.theme.dark = this.$store.state.dark
    this.$root.$i18n.locale = this.$store.state.lang
    this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary = this.$store.state.theme_color
    if (this.$store.state.rtl) {
      this.$vuetify.rtl = true
      storage.init.rtl.value = true
      localStorage.setItem('token', JSON.stringify(storage))
    } else {
      this.$vuetify.rtl = false
    }
    var layout = localStorage.getItem('invoicePrintLayout')
    var size = localStorage.getItem('invoicePrintSize')
    if (layout !== undefined) {
      this.layout = layout
    }
    if (size !== undefined) {
      this.size = size
    }
    if (!this.size) {
      this.size = 'a4'
    }
    if (!this.layout) {
      this.layout = 'portrait'
    }
  },
  mounted () {
    if (this.itemsProp) {
      this.items = this.itemsProp
    }
    this.setDefaultCooki()
    this.getBase64Logo()
  },
  methods: {
    statusLabel (item) {
      const total = +item.cumulative_debtor - +item.cumulative_creditor + +item.initial
      if (total > 0) {
        return this.$t('deb')
      } else if (total < 0) {
        return this.$t('cred')
      } else {
        return ''
      }
    },
    calculateDynamicSums () {
      var app = this
      let firstRowCells = 0
      const rows = document.querySelectorAll('.body-print .print-article')
      const columnSums = []
      const columnNames = []
      if (rows.length > 0) {
        firstRowCells = rows[0].querySelectorAll('.table-body-td-print')
        firstRowCells.forEach((cell, index) => {
          if (cell.classList.contains('sum-type')) {
            columnNames[index] = cell.innerText.trim()
            columnSums[index] = 0
          }
        })
      }
      rows.forEach(row => {
        const cells = row.querySelectorAll('.table-body-td-print')
        cells.forEach((cell, index) => {
          const cellValue = parseFloat(cell.innerText.replace(/,/g, '').trim()) || 0
          if (!isNaN(cellValue)) {
            columnSums[index] += cellValue // جمع‌بندی عددی
          }
        })
      })
      const resultRow = document.createElement('div')
      resultRow.classList.add('print-article', 'print-article-sum', 'show-header', 'd-flex')
      resultRow.style.display = 'flex'
      let resultRowHTML = ''
      columnSums.forEach((sum, index) => {
        const formattedSum = sum.toLocaleString()
        var style = ''
        if (index === 0) {
          style = 'display: inline-block !important;' +
              '  width: ' + firstRowCells[index].style.width + ' ;' +
              '  font-size: 10px !important;' +
              '  padding: 3pt !important;' +
              '  word-wrap: break-word !important;' +
              '  word-break: break-all !important;' +
              '  border-bottom-right-radius: 10px;' +
              '  border-top: none !important;' +
              '  border: 0.5px solid #000000'
        }
        if (isNaN(sum) && index !== 0) {
          style = 'display: inline-block !important;' +
              '  width: ' + firstRowCells[index].style.width + ' ;' +
              '  font-size: 10px !important;' +
              '  padding: 3pt !important;' +
              '  word-wrap: break-word !important;' +
              '  word-break: break-all !important;' +
              '  border-left: none !important;' +
              '  border-right: none !important;' +
              '  border-top: none !important;' +
              '  border: 0.5px solid #000000'
        }
        if (!isNaN(sum) && index !== 0) {
          style = 'display: inline-block !important;' +
              '  width: ' + firstRowCells[index].style.width + ' ;' +
              '  font-size: 10px !important;' +
              '  padding: 3pt !important;' +
              '  word-wrap: break-word !important;' +
              '  word-break: break-all !important;' +
              '  border-top: none !important;' +
              '  border: 0.5px solid #000000'
        }
        if (index === columnSums.length - 1) {
          style = 'display: inline-block !important;' +
              '  width: ' + firstRowCells[index].style.width + ' ;' +
              '  font-size: 10px !important;' +
              '  padding: 3pt !important;' +
              '  word-wrap: break-word !important;' +
              '  word-break: break-all !important;' +
              '  border-bottom-left-radius: 10px;' +
              '  border-right: none !important;' +
              '  border-top: none !important;' +
              '  border: 0.5px solid #000000'
        }
        if (index === 0) {
          resultRowHTML += '<div class="" ' +
              'style="' + style + '"><div>' + app.$t('sum') + '</div></div>'
        } else {
          resultRowHTML += '<div class="" ' +
              'style="' + style + '"><div>' + (isNaN(sum) ? '' : formattedSum) + '</div></div>'
        }
      })
      resultRow.innerHTML = resultRowHTML
      document.querySelector('.pagemargins:last-child > .body-print').appendChild(resultRow)
    },
    calculateSumsForTable () {
      // دسترسی به جدول
      var table = document.getElementById('print')

      // آرایه‌ای برای نگه‌داری مجموع هر ستون
      var columnSums = []

      // دسترسی به تمام ردیف‌ها به جز ردیف‌های هدر
      var rows = table.getElementsByTagName('tbody')[0].getElementsByTagName('tr')

      // پیمایش ردیف‌های داده (غیر از هدر)
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i]

        // پیمایش سلول‌های هر ردیف
        for (var j = 1; j < row.cells.length; j++) { // شروع از ستون 1، چون ستون اول ممکن است فقط شمارش باشد
          var cellText = row.cells[j].innerText.replace(/,/g, '').trim()
          var cellValue = parseFloat(cellText) || 0

          // اطمینان از اینکه ستون‌ها به درستی شناسایی شده‌اند
          if (!isNaN(cellValue)) {
            // اگر آرایه‌ای برای جمع این ستون هنوز وجود ندارد، ایجاد کنیم
            if (!columnSums[j]) {
              columnSums[j] = 0
            }
            // اضافه کردن مقدار سلول به جمع ستون مربوطه
            columnSums[j] += cellValue
          }
        }
      }
    },
    captureAndSharePDF (type) {
      this.pdfGenerate = true
      this.loading = true
      const app = this

      setTimeout(() => {
        const element = document.getElementById('print')
        const layout = app.layout === 'portrait' ? 'p' : 'l'
        const imgWidth = layout === 'p' ? 210 : 297
        const pageHeight = layout === 'p' ? 297 : 210

        if (window.html2canvas) {
          window.html2canvas(element, {
            scale: 2,
            logging: true,
            letterRendering: 1
          }).then((canvas) => {
            const imgData = canvas.toDataURL('image/png')
            const pdf = window.jspdf.jsPDF(layout, 'mm', 'a4')
            const imgHeight = app.printPage.length * pageHeight
            let position = 0
            let heightLeft = imgHeight

            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, null, 'FAST')
            heightLeft -= pageHeight

            while (heightLeft >= 0) {
              position = heightLeft - imgHeight
              pdf.addPage()
              pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, null, 'FAST')
              heightLeft -= pageHeight
            }

            const nameFile = `${app.title} - ${app.getToday()}.pdf`

            if (type === 'pdf') {
              pdf.save(nameFile)
              app.pdfGenerate = false
            } else {
              const pdfBlob = pdf.output('blob')
              const file = new File([pdfBlob], nameFile, { type: 'application/pdf' })

              if (navigator.canShare && navigator.canShare({ files: [file] })) {
                navigator.share({
                  title: `${app.title} - ${app.$store.state.abrName}`,
                  text: `${app.title} - ${app.$store.state.abrName} - ${app.getToday()}`,
                  files: [file]
                }).then(() => {
                  app.pdfGenerate = false
                })
              }
            }
          })
        }

        app.loading = false
      }, 200)
    },
    entrepotArticleName (item) {
      var content = ''
      if (this.entrepot && this.showEntrepotArticle) {
        content = '    |    ' + this.$t('entrepot') + ' : ' + this.entrepot.entrepot.name
      }
      if (item.article_entrepot && this.showEntrepotArticle) {
        content = '    |    ' + this.$t('entrepot') + ' : ' + item.article_entrepot.name
      }
      return content
    },
    renderPrinter () {
      var app = this
      clearTimeout(this.timer)
      this.timer = setTimeout(function () {
        app.printPage = []
        app.$refs.refItems.style.display = ''
        setTimeout(function () {
          var minusHeight = 0
          if (app.layout === 'landscape') {
            minusHeight = 150
          }

          var maxHeight = +900 - +minusHeight

          if (app.self && app.self.invoiceContent) {
            maxHeight = +800 - +minusHeight
          }
          if (app.template && app.color) {
            maxHeight = +800 - +minusHeight
          }
          var div = app.$refs.refItems
          var divRow = div.getElementsByClassName('print-row')
          var startHeight = 0
          var startHeightTemp = 0
          var pageItems = []
          var items = []
          var tempitems = []
          for (let j = 0; j < divRow.length; j++) {
            startHeight = startHeight + divRow[j].offsetHeight
            // var endPrint = divRow[j].classList.contains('end-print')
            if (startHeight <= maxHeight) {
              items.push(divRow[j].innerHTML)
            } else {
              tempitems.push(divRow[j].innerHTML)
              startHeightTemp = divRow[j].offsetHeight
            }
            if (startHeight > maxHeight) {
              pageItems.push(items)
              items = []
              items = JSON.parse(JSON.stringify(tempitems))
              tempitems = []
              startHeight = startHeightTemp
            }
          }
          pageItems.push(items)
          for (let i = 0; i < pageItems.length; i++) {
            var hideHeader = true
            for (let d = 0; d < pageItems[i].length; d++) {
              if (pageItems[i][d].includes('table-body-td-print')) {
                hideHeader = false
              }
            }
            app.printPage.push({
              page: i + 1,
              itemStart: 0,
              itemEnd: 1,
              hideHeader: hideHeader,
              items: pageItems[i]
            })
          }
        }, 100)
        setTimeout(function () {
          app.$refs.refItems.style.display = 'none'
          app.calculateDynamicSums()
        }, 1000)
      }, 100)
    },
    setDefaultCooki () {
      var showRemain = (this.getCookie('showRemain') !== null ? this.getCookie('showRemain') : null)
      if (showRemain) {
        if (showRemain === 'true') {
          this.showRemain = true
        } else {
          this.showRemain = false
        }
      }
    },
    edit () {
      this.$router.push({ name: this.type + 'Edit', params: { id: this.uid } })
    },
    entrepotPrint () {
      this.$router.push({ name: this.entrepot.type + 'Print', params: { id: this.entrepot.id } })
    },
    clearCustom () {
      this.height = null
      this.width = null
    },
    setCustomeSize () {
      this.printSize = this.width + 'cm ' + this.height + 'cm'
      this.customSizeDialog = false
    },
    print () {
      var style = '<style>' +
          '@page {size: ' + this.size + ' ' + this.layout + ';margin: 5px}' +
          'html {font-size: inherit !important; line-height:1.5},body { width: 190mm; height: 290mm} .pagemargins { padding: 5.08mm 10mm 5.08mm 10mm; border:0;direction: rtl; }' +
          '' + (this.$store.state.lang !== 'fa' ? 'body {font-family: arial !important;}' : '') +
          '</style>'
      setTimeout(function () {
        // Get HTML to print from element
        const prtHtml = document.getElementById('print').innerHTML

        var stylesHtml = ''
        var node = null
        for (node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML
        }

        const WinPrint = window.open('', '', 'left=0,top=0,width=1100,height=900,toolbar=0,scrollbars=0,status=0')
        WinPrint.document.write('<!DOCTYPE html> <html> <head> ' + stylesHtml + ' ' + style + ' </head> <body>' + prtHtml + ' </body> </html>')
        WinPrint.document.close()
        WinPrint.focus()
        setTimeout(function () {
          WinPrint.print()
          WinPrint.close()
        }, 2000)
      }, 50)
    },
    copied () {
      this.snakbarText = this.$t('copied')
      this.snakbarColor = 'blue'
      this.snakbar = true
    },
    getBase64Logo () {
      var app = this
      var logo = localStorage.getItem('token')
      logo = JSON.parse(logo)
      logo = logo.init.logo
      if (logo) {
        app.$axios.get(app.$endpoint + 'getdetail?select=urlToBase64&url=' + logo.link)
          .then(res => {
            res = res.data
            app.base64Logo = res
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
      }
    }
  }
}
</script>

<style scoped>
.top-header-print {
  font-size:10px;
  border-radius: 10px;
  border: 1px solid #292929;
  display: flex
}
@page  {
  /*size: A4 landscape;*/
}
@media print {
  @page  {
    /*size: A4;*/
    margin: 0px;
    padding: 0;
  }
  .main-page-print {
    width: 21cm;
    height: 29.68cm;
    position: relative;
    border: 0px !important;
    padding: 10px;
    white-space: normal;
  }
  .main-page-landscape-print {
    border: 0px solid !important;
    padding: 10px;
    white-space: normal;
  }
  .table-header-td-print {-webkit-print-color-adjust: exact !important;}
  .body-print > .print-article:nth-child(even) > .table-body-td-print {
    -webkit-print-color-adjust: exact !important;
  }
}
.pagemargins { padding: 5.08mm 10mm 5.08mm 10mm; border:0;direction: rtl; }
.footer-page-print {
  position: absolute;
  bottom: 28px;
  border-radius: 10px;
  padding: 3px 7px;
  right: 0.5cm;
  background-color: #ffffff;
  font-size: 10px
}
.footer-abriron-print {
  position: absolute;
  bottom: 28px;
  border-radius: 10px;
  padding: 3px 7px;
  left: 0.7cm;
  font-size: 9px;
  background-color: #ffffff;
  color: #1c1c1c;
}
.table-header-td-print {
  display: inline-block;
  width: 1cm;
  border: 0.5px solid #262626;
  height: 30px;
  font-size: 10px;
  border-left: none !important;
  padding: 5px;
  background-color: #e7e7e7;
}

.table-header-print {
  display: flex;
  width: 100%;
  /*margin: 0cm 0.2cm;*/
}
.border-off {
  border: 0px !important;
}
.main-page-landscape-print {
  width: 29.68cm;
  height: 20.8cm;
  position: relative;
  border: 0.5px solid ;
  padding: 10px;
  white-space: normal;
}
.main-page-print {
  width: 21cm;
  height: 29.68cm;
  position: relative;
  border: 0.5px solid ;
  padding: 10px;
  white-space: normal;
}
.body-print {
  direction: rtl;
  width: 100%;
  right: 0;
}
.body-print > .print-article:last-child > div:first-child {
  border-bottom-right-radius: 10px;
}
.body-print > .print-article:last-child > div:last-child {
  border-bottom-left-radius: 10px;
}
.share-button {
  width: 28px;
  height: 28px;
  min-width: 0px !important;
  min-height: 0px !important;
  padding: 0px 0px !important;
}
.page-background-print{
  position: absolute;
  width: 100%;
  top: 0;
  right: 0;
  padding: 10px;
}
.table-header-td-print:first-child {
  border-top-right-radius: 10px;
}
.table-header-td-print:last-child {
  border-top-left-radius: 10px;
  border-left: 0.5px solid #262626 !important;
}
.print-row > .table-body-td-print {
  /*border: 0.5px solid #ffffff;*/
  /*color: #ffffff*/
}
.table-body-td-print {
  display: inline-block !important;
  font-size: 10px !important;
  padding: 3pt !important;
  word-wrap: break-word !important;
  white-space: normal;
  word-break: break-word !important;
  /*min-height: 25px;*/
  border-left: none !important;
  border-top: none !important;
  border: 0.5px solid #000000
}
.table-body-td-print:last-child {
  border-left: 0.5px solid #000000 !important;
}
.print-article {
  display: flex;
  width: 100%;
  margin: 0cm 0cm;
}
.body-print > .print-article:nth-child(even) > .table-body-td-print {
  background-color: #e7e7e7;
}
@media only screen and (max-width: 870px)  {
  /*.main-layout {*/
  /*  zoom: 0.45;*/
  /*}*/
}

</style>
